export { default } from './MilitaryRankOne'
